import type { EntityType } from '@datahub/shared'

/**
 * Where an entity's admin page lives. Companies and funds are the same record, but they
 * are listed and worked on apart, so a link has to know which book its subject is in —
 * the API refuses a fund on `/admin/companies` and a company on `/admin/funds`.
 */
export function entityBasePath(entityType: EntityType | string | null | undefined): string {
  return entityType === 'gp' || entityType === 'lp' ? '/admin/funds' : '/admin/companies'
}

export function entityPath(entityType: EntityType | string | null | undefined, id: string): string {
  return `${entityBasePath(entityType)}/${id}`
}
